import React from 'react';

import icons from '../utils/icons';

export default function SvgIcon({ name }) {
  return icons[name] ? icons[name] : <></>;
}
